import {couponDetailReportExport} from "@/api/assets";
import config from '@/config'
import {parseParam} from '@/libs/util'
import { iscode } from '@/utils/app';
import { message } from 'ant-design-vue';
export function  userExportTable(){
  const exportHandle=async (data)=>{
    var params=parseParam(data)
    const hide = message.loading('导出中...', 0);
    let result =await couponDetailReportExport(data).then(res=>res.data).catch(error=>error)
    setTimeout(hide);
    //  window.open()config.baseUrl[process.env.VUE_APP_type]+url+'?'+params
    if(iscode(result)){
        message.success('导出中,文件请在生成报表查看！')
    }else{
      message.error(result.msg)

    }
  }
  return{
    exportHandle
  }
}